import BaseAPI from "@/api/BaseAPI";

export const parts = ['part1a', 'part1b', 'part1v', 'part2', 'part3', 'part4', 'part5', 'part6', 'part7', 'part8', 'part9',
  'part10', 'part11', 'part12a', 'part12b', 'part13', 'part14', 'part15', 'part16', 'part17', 'part18', 'part19', 'part20', 'part21', 'part22'];

export class FormFivesAPI extends BaseAPI {
  constructor() {
    super('/form5');
  }

  /**
   * @param {Number} id orgID
   * @param {'part1a','part1b','part1v','part2', 'part3', 'part4', 'part5', 'part6', 'part7', 'part8', 'part9',
   * 'part10', 'part11', 'part12a','part12b', 'part13', 'part14', 'part15', 'part16', 'part17', 'part18', 'part19', 'part20', 'part21', 'part22'} part
   * @param {boolean} full
   * */
  read(id, part, full = false) {
    return this.http.get(`/${part}/get`, {data: {orgId: id, full}})
  }

  /**
   * @param {
   *     {
   *   "id": number,
   *   "spec": {
   *     "id": number,
   *   },
   *   "kcpUgs": {
   *     "id": number
   *   },
   *   "orgId": number,
   *   "gpsnm23K22": "string",
   *   "gpsnp23K22": "string",
   *   "gpdtb23K22": "string",
   *   "gpdte23K22": "string",
   *   "gptxt23K22": "string"
   * }
   * } data
   * */
  changeForm5(data) {
    return this.http.post('/part5/set', {data})
  }

  changeForms(data) {
    return this.http.put('/set', {data})
  }

  /**
   * @param {number} identifier rowId
   * */
  deleteFormFive(identifier) {
    return this.http.delete('/part5/delete', {data: {rowId: identifier}})
  }
}

export default new FormFivesAPI()